import { render, staticRenderFns } from "./CopilotoEvento.vue?vue&type=template&id=6479eaa3&"
import script from "./CopilotoEvento.vue?vue&type=script&lang=ts&"
export * from "./CopilotoEvento.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports